import React from 'react';
import { Card } from './ui/Card';
import { Heart, Zap, Users } from 'lucide-react';
const principles = [{
  title: 'Automation with Heart',
  description: 'Technology should support, not replace. Personal support is standard with me, not an extra.',
  icon: Heart
}, {
  title: 'Practice over Theory',
  description: "We don't develop systems in ivory towers. Every feature was tested and optimized in real-world practice.",
  icon: Zap
}, {
  title: 'True Partnership',
  description: 'You work directly with me. No anonymous support tickets, but real partnership on equal footing.',
  icon: Users
}];
export function PhilosophySection() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-102" data-mp="1z2uqai7oe1og">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103" data-mp="1z57j5qez1wga">
        <div className="text-center mb-16" data-id="element-104" data-mp="2e1ge4frtxnmw">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-105" data-mp="2dy0z1cy5oelh">
            My Approach
          </h2>
          <div className="h-1 w-20 bg-[#FF5722] mx-auto rounded-full" data-id="element-106" data-mp="2gyzp45cizt67"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-107" data-mp="2h1cfn6wcnbuv">
          {principles.map((item, index) => <div key={index} className="text-center group" data-id="element-108" data-mp="2pzo5h6pe65m9" data-mpi={index}>
              <div className="w-16 h-16 mx-auto bg-[#141B3A] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-[#1E293B] group-hover:border-[#FF5722]" data-id="element-109" data-mp="2pycy6wwqmfqe">
                <item.icon className="w-8 h-8 text-[#FF5722]" data-id="element-110" data-mp="2zw14mk3phboe" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-111" data-mp="34v3xz7abptgj">
                {item.title}
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-112" data-mp="39q17efbim4ty">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}